import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useAppSelector, useAppDispatch } from '../reduxhooks';
import { Button, Box, Typography, CircularProgress, Grid, Radio, Switch } from '@material-ui/core';
import React, { SetStateAction } from 'react';
import { calculateCompleteCartInvoice, getCourierOptions, getEndShipmentPrice, getNumberOfItems, getSubsidyItems, resetCourier, setInsuranceSelected, updateCourierInOrder } from '../redux/CartRedux';
import { getStoreShippingConfig } from '../terbebasApi';
import { ArrowBack } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import { sendWebsiteEventMessage, sendWebsiteLivestreamMessage } from '../telegrambotevents';
import { FareastButton } from './OverlayComponentButton';

const useStyles = makeStyles((theme: Theme) =>
createStyles({
  nextStepButtonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    marginTop: '16px',
  },
  circularProgressContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "250px",
  },
  addressSegmentBody: {
  },
  title: {
    padding: '20px 20px 16px 20px',
    fontWeight: theme.typography.fontWeightBold as number,
    fontSize: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
  containerStyle: {
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop: '5px',
    paddingBottom: '10px',
  },
  nameText: {
    fontWeight: theme.typography.fontWeightBold as number,
    fontSize: '16px',
    marginBottom: '4px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    },
  },
  bodyText: {
    fontWeight: theme.typography.fontWeightMedium as number,
    fontSize: '15px',
    marginLeft: '3px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  buttonStyle: {
    marginTop: '5px',
  },
  chooseAddressButton: {
    marginTop: '12px',
  },
  courierContainer: {
    padding: "10px 17px 8px 17px",
    position: "relative",
  },
  courierContainerInner: {
    padding: "12px 3px 8px 3px",
    borderTop: '1px solid #cecece',
  },
  courierContainerText: {
    position: "relative"
  },
  barIconArrowBack: {
    padding: '18px 10px 0px 16px',
    margin: '0px',
    color: '#000',
  },
  courierLogo: {
    width: "40px",
    paddingRight: "10px"
  },
  serviceNameText: {
    fontSize: "20px",
    fontWeight: 600,
  },
  subTitleText: {
    paddingTop: "8px",
    fontSize: "13px",
    fontWeight: 500,
  },
  contentText: {
    marginTop: "2px",
    fontSize: "12px",
    fontWeight: 300,
  },
  contentTextFreeOngkir: {
    marginTop: '3px',
    borderRadius: '20px',
    border: '1px solid rgb(200,200,200)',
    fontSize: "11px",
    fontWeight: 500,
    letterSpacing: '0.04px',
    textAlign: 'center',
    width: 'fit-content',
    padding: '4px 8px 2px',
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      padding: '4px 0px 2px',
      letterSpacing: '0.01px',
      fontSize: "9.5px",
    },
  },
  serviceNameContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  rekomendasiTextSpacerBox: {
    width: "3px",
    height: "21px",
  },
  rekomendasiTextCont: {
    width: "fit-content",
    paddingTop: "3px",
    paddingBottom: "6px",
    paddingLeft: "1px",
  },
  rekomendasiText: {
    fontSize: "8px",
    backgroundColor: "green",
    fontWeight: 500,
    letterSpacing: "0.4px",
    borderRadius: "10px",
    color: "white",
    padding: "4px 8px 2px 8px"
  },
  dipilihTextCont: {
    width: "fit-content",
    paddingLeft: "8px",
    paddingTop: "2px",
    position: "absolute",
    top: "34px",
    right: "30px",
  },
  dipilihText: {
    fontSize: "13px",
    backgroundColor: "#0f1488",
    fontWeight: 500,
    letterSpacing: "0.4px",
    color: "white",
    padding: "4px 4px 2px 4px"
  },
  originalShipmentPriceText: {
    fontSize: "12px",
    color: "red",
    textDecoration: "line-through",
    marginRight: "12px",
  }
}),
);

const courierImagesDict: {[key:string]: string} = {
    "sicepat":  "https://studiosclo.uk/general/logistik-sicepat.png",
    "jne":      "https://studiosclo.uk/general/logistik-jne.png",
    "jnt":      "https://studiosclo.uk/general/logistik-jnt-express.png",
    "sap":      "https://studiosclo.uk/general/logistik-sap-express.png",
    "lion":     "https://studiosclo.uk/general/logistik-lion.png",
    "idx":      "https://studiosclo.uk/general/logistik-id-express.png",
    "anteraja": "https://studiosclo.uk/general/logistik-anteraja.png",
    "spx":      "https://studiosclo.uk/general/logistik-spx.png",
    "sentral":  "https://studiosclo.uk/general/logistik-sentral-kargo.jpeg",
    "ncs":      "https://studiosclo.uk/general/logistik-ncs.png",
    "ninja":    "https://studiosclo.uk/general/logistik-ninja.png",
    "tiki":     "https://studiosclo.uk/general/logistik-tiki.png",
    "jtcargo":  "https://studiosclo.uk/general/logistik-jnt.png",
}

interface PageCheckoutProps {
  checkoutStep: string,
  setCheckoutStep: React.Dispatch<SetStateAction<string>>,
  isDisabled: boolean,
  handleSubmit: () => void
}

export default function PageCheckoutCourier({ checkoutStep, setCheckoutStep, isDisabled, handleSubmit } : PageCheckoutProps) {
  const dispatch = useAppDispatch();
  const classes = useStyles();

  const [selectedIndex, setSelectedIndex] = React.useState<number>(-1);
  const [currentlyMakingOrder, setCurrentlyMakingOrder] = React.useState(false);

  const productsList = useAppSelector((state) => state.productsList);
  const userBodyMeasurementsDict = useAppSelector(state => state.userMeasurementsList.userBodyMeasurementsDictionary);
  const userClothingMeasurementsDict = useAppSelector(state => state.userMeasurementsList.userClothingMeasurementsDictionary);
  const paidOrderCountInAcc = useAppSelector((state) => (state.account?.paidOrderCount ?? 0));

  const cart = useAppSelector((state) => state.cart);
  const courierOptions = useAppSelector(state => state.cart.courierOptions ? state.cart.courierOptions : []);
  const courierOptionsFetchStatusLoading = useAppSelector(state => state.cart.courierOptionsFetchStatus === APIRequestStatus.RequestInProgress);

  const completeCartInvoiceObj = calculateCompleteCartInvoice(cart, productsList, userBodyMeasurementsDict, userClothingMeasurementsDict);
  const originalPriceAmount = completeCartInvoiceObj.totalAmountObj.originalPriceAmount;
  const discountedPriceAmount = completeCartInvoiceObj.totalAmountObj.discountedPriceAmount;
  const discountedPriceAmountWithPromotions = completeCartInvoiceObj.totalAmountObj.discountedPriceAmountWithPromotions;
  const discountedPriceAmountWithPromotionsAndShipment = completeCartInvoiceObj.totalAmountObj.discountedPriceAmountWithPromotionsAndShipment;

  // Tenant subsidy + coupon free-shipping applied per courier option.
  const subsidyItems = getSubsidyItems(cart, productsList);
  const chargedShipmentPrice = (cost: number) =>
    getEndShipmentPrice(subsidyItems, cost, cart?.coupon) as number;

  // Per-store approved couriers (StoreConfig.shipping.courierOptions).
  // Empty = allow every courier the quote returns.
  const approvedCouriers = getStoreShippingConfig().courierOptions ?? [];

  const filteredCourierOptions = ([...courierOptions])
  .sort((a: any, b: any) => Number(a.cost) - Number(b.cost))
  .filter((item) => item.etd &&
    item.etd !== "-" &&
    !(item.service_name?.toLowerCase()?.includes("same")) && // Filter out null entries and same day services
    !(item.group?.includes("one_day")) && // Filter out null entries and same day services
    (approvedCouriers.length === 0 || approvedCouriers.includes(item.service)));

  // Tenant opt-in (Pengaturan > KiriminAja): without it the toggle never
  // renders and no insurance fee is ever folded in.
  const insuranceEnabled = !!getStoreShippingConfig().insuranceEnabled;
  const insuranceSelected = insuranceEnabled && !!cart.insuranceSelected;

  const costMarkup = 7000;
  // The displayed/charged cost folds in the markup plus the quote's insurance
  // fee (chosen via the toggle, or forced by the courier). costOriginal keeps
  // the raw KiriminAja quote — request pickup sends THAT as shipping_cost.
  let orderedCourierOptions = filteredCourierOptions?.map((courierObj) => {
    const insuranceFee = insuranceEnabled && (insuranceSelected || courierObj.force_insurance)
      ? (Number(courierObj.insurance) || 0)
      : 0;
    return {
      ...courierObj,
      costOriginal: Number(courierObj?.cost ?? 0),
      cost: "" + ((Number(courierObj?.cost ?? 0)) + costMarkup + insuranceFee),
    };
  });

  // Auto-select the cheapest approved courier and skip straight to payment
  // (StoreConfig.shipping.autoSelectCheapestCourier). The customer never
  // interacts with this page — it shows a brief "preparing" spinner.
  const autoSelectCheapest = !!getStoreShippingConfig().autoSelectCheapestCourier;
  const autoSelectedRef = React.useRef(false);
  React.useEffect(() => {
    if (!autoSelectCheapest || autoSelectedRef.current) return;
    if (courierOptionsFetchStatusLoading) return;
    const cheapest = orderedCourierOptions?.[0];
    if (!cheapest) return;
    autoSelectedRef.current = true;
    dispatch(updateCourierInOrder({
      shipmentPrice: Number(cheapest.cost),
      shipmentPricePaid: Number(cheapest.cost) - costMarkup,
      estimasiPengiriman: cheapest.etd,
      courierSelectionObject: cheapest,
    }));
    sendWebsiteLivestreamMessage("[CHECKOUT] Auto-selected cheapest courier " + cheapest.service_name);
    setTimeout(() => handleSubmit(), 60);
  }, [autoSelectCheapest, courierOptionsFetchStatusLoading, orderedCourierOptions?.length]);

  if (autoSelectCheapest) {
    return (
      <Box className={classes.circularProgressContainer}>
        <CircularProgress/>
        <Typography variant="h5" className={classes.title} style={{ marginTop: 12 }}>
          Menyiapkan pengiriman...
        </Typography>
      </Box>
    );
  }

  return (
    <Box className={classes.addressSegmentBody}>
      <IconButton
        className={classes.barIconArrowBack}
        color="primary"
        aria-label="open drawer"
        edge="start"
        onClick={() => {
          dispatch(resetCourier());
          setCheckoutStep("address");
        }}
      >
        <ArrowBack fontSize={"medium"}/>
        <Typography variant="h5" className={classes.title}>
          Pilih Kurir
        </Typography>
      </IconButton>
      {
        insuranceEnabled ?
        <Box style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '0px 20px 8px 20px',
        }}>
          <Box>
            <Typography style={{ fontWeight: 600, fontSize: '15px' }}>
              Pakai Asuransi
            </Typography>
            <Typography style={{ fontSize: '13px', color: '#676767' }}>
              Lindungi paketmu — ongkir menyesuaikan
            </Typography>
          </Box>
          <Switch
            checked={insuranceSelected}
            disabled={courierOptionsFetchStatusLoading}
            onChange={(event) => {
              const next = event.target.checked;
              // Flipping invalidates every quoted price: clear the selection
              // and refetch rates with the new insurance preference (the
              // thunk reads insuranceSelected and the cart lines from state).
              dispatch(setInsuranceSelected(next));
              setSelectedIndex(-1);
              const dest = cart.destinationKiriminAjaObject?.kecamatan_id;
              if (dest) {
                dispatch(getCourierOptions({ dest }));
              }
              sendWebsiteLivestreamMessage("[CHECKOUT] Asuransi pengiriman " + (next ? "ON" : "OFF"));
            }}
            color="primary"
          />
        </Box>
        : null
      }
      <Box>
        {
          courierOptionsFetchStatusLoading ? 
          <Box className={classes.circularProgressContainer}>
            <CircularProgress/>
          </Box>:
          orderedCourierOptions.map((item: any, index: number) => {
            return (
            <Box className={classes.courierContainer} onClick={() => {
              dispatch(updateCourierInOrder({
                shipmentPrice: Number(item.cost),
                shipmentPricePaid: Number(item.cost) - costMarkup,
                estimasiPengiriman: item.etd,
                courierSelectionObject: item,
              }));
              setSelectedIndex(index);
              sendWebsiteLivestreamMessage("[CHECKOUT] Courier " + item.service_name + " harga " + item.cost + " diselect.");
            }}>
              <Grid container className={classes.courierContainerInner}>
                <Grid item xs={2}>
                  {
                    index === 0 ? 
                    <Box className={classes.rekomendasiTextSpacerBox}></Box>:
                    null
                  }
                  <Radio checked={index === selectedIndex} style={{ color: index === selectedIndex ? "#232323" : "#676767" }}/>
                </Grid>
                <Grid item xs={10} className={classes.courierContainerText} >
                  {
                    index === selectedIndex ? 
                    <Box style={{
                      position: 'absolute',
                      top: '18px', right: '0px',
                    }}>
                    <FareastButton onClick={() => {
                      setCurrentlyMakingOrder(true);
                      handleSubmit();

                      setTimeout(() => {
                        setCurrentlyMakingOrder(false);
                      }, 9000); // Give 9 s delay before each order creation
                    }}
                    disabled={!cart.courierSelectionObject || !cart.shipmentPrice || currentlyMakingOrder} buttonMarginLeftRight="2px"
                    buttonMarginTopBottom="6px" style={{padding: '6px 9px 2px'}}>
                      {
                        currentlyMakingOrder ?
                        <CircularProgress style={{width: '20px', height: '20px', margin: '0px 7px 3px'}}/>:
                        <span style={{fontWeight: 500}}>PILIH</span>
                      }
                    </FareastButton>
                    </Box>
                    : null
                  }
                  {
                    index === 0 ? 
                    <Box className={classes.rekomendasiTextCont}>
                      <Typography className={classes.rekomendasiText}>
                        REKOMENDASI
                      </Typography>
                    </Box>:
                    null
                  }
                  <Box className={classes.serviceNameContainer}>
                    <img 
                    src={courierImagesDict[item.service as string]} 
                    alt={"key-" + index}
                    className={classes.courierLogo}/>
                    <Typography className={classes.serviceNameText}>
                      {item.service_name}
                    </Typography>
                    {
                      insuranceEnabled && item.force_insurance && !insuranceSelected ?
                      <Typography style={{
                        fontSize: '11px', fontWeight: 600, color: '#676767',
                        border: '1px solid #c4c4c4', borderRadius: '4px',
                        padding: '1px 6px', marginLeft: '8px',
                      }}>
                        Asuransi wajib
                      </Typography>
                      : null
                    }
                  </Box>
                  <Grid container direction='row'>
                    <Grid item xs={6}>
                      <Typography className={classes.subTitleText}>
                        {"Estimasi Pengiriman"}
                      </Typography>
                      <Typography className={classes.contentText}>
                        {item.etd + " hari"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography className={classes.subTitleText}>
                        {"Price"}
                      </Typography>
                      <Typography className={classes.contentText}>
                        {
                          chargedShipmentPrice(Number(item.cost)) !== Number(item.cost) ?
                          <span className={classes.originalShipmentPriceText}>{"Rp " + Number(item.cost).toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span> :
                          null
                        }
                        {
                          chargedShipmentPrice(Number(item.cost)) === 0 ?
                          "FREE" :
                          "Rp " + chargedShipmentPrice(Number(item.cost)).toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>)
          })
        }
      </Box>
      <Box className={classes.nextStepButtonContainer}>
        <FareastButton onClick={() => {
            setCurrentlyMakingOrder(true);
            handleSubmit();

            setTimeout(() => {
              setCurrentlyMakingOrder(false);
            }, 9000); // Give 9 s delay before each order creation
        }}
          disabled={!cart.courierSelectionObject || !cart.shipmentPrice || currentlyMakingOrder} buttonMarginLeftRight="20px"
          buttonMarginTopBottom="6px">
          {
            currentlyMakingOrder ?
            <CircularProgress style={{width: '20px', height: '20px', margin: '0px 7px 3px'}}/>:
            <b>LANJUT</b>
          }
        </FareastButton>
      </Box>
    </Box>
  );
}
